import { useCallback } from 'react';
import { supabase } from '../services/supabaseService';

const MIN_REDUCTION_PERCENT = 1;
const MIN_REDUCTION_AMOUNT = 50; // minimalna obniżka w zł
const COOLDOWN_DAYS = 7;
const TEST_EMAILS = ['mejermaciej@gmail.com', 'x@gmail.com'];

const parsePrice = (v) => parseInt(String(v).replace(/[^\d]/g, ''), 10) || 0;

/**
 * Hook do zarządzania logiką obniżek cen ogłoszeń.
 * Rejestruje obniżkę w Supabase gdy cena spada o min. MIN_REDUCTION_PERCENT
 * i min. MIN_REDUCTION_AMOUNT zł, z cooldownem COOLDOWN_DAYS dni.
 */
export const usePriceReduction = () => {
  const registerPriceChange = useCallback(async ({ propertyId, userId, userEmail, oldProperty, updatedData }) => {
    if (!oldProperty || updatedData.price == null) {
      console.warn('[PriceReduction] Brak danych: oldProperty=', !!oldProperty, 'price=', updatedData?.price);
      return;
    }

    const isTestAccount = TEST_EMAILS.includes(userEmail?.toLowerCase());
    const oldPrice = parsePrice(oldProperty.price);
    const newPrice = parsePrice(updatedData.price);

    if (newPrice < oldPrice && oldPrice > 0) {
      const reduction = ((oldPrice - newPrice) / oldPrice) * 100;
      const reductionAmount = oldPrice - newPrice;
      const lastReduction = oldProperty.price_reduced_at
        ? new Date(oldProperty.price_reduced_at)
        : null;

      const cooldownOk = isTestAccount || !lastReduction ||
        (Date.now() - lastReduction.getTime() > COOLDOWN_DAYS * 24 * 60 * 60 * 1000);

      const amountOk = isTestAccount || reductionAmount >= MIN_REDUCTION_AMOUNT;

      if (reduction >= MIN_REDUCTION_PERCENT && amountOk && cooldownOk) {
        const now = new Date().toISOString();
        const { error } = await supabase
          .from('properties')
          .update({
            previous_price: oldPrice,
            price_reduced_at: now,
            last_price_change_at: now,
          })
          .eq('id', propertyId)
          .eq('user_id', userId);

        if (error) {
          console.error('[PriceReduction] Błąd zapisu obniżki:', error.message);
        }
      } else if (!cooldownOk) {
        // cooldown aktywny
      } else {
        // obniżka za mała
      }
    } else if (newPrice > oldPrice) {
      const { error } = await supabase
        .from('properties')
        .update({
          previous_price: null,
          price_reduced_at: null,
          last_price_change_at: new Date().toISOString(),
        })
        .eq('id', propertyId)
        .eq('user_id', userId);

      if (error) {
        console.error('[PriceReduction] Błąd czyszczenia obniżki:', error.message);
      }
    } else {
      // cena bez zmian
    }
  }, []);

  return { registerPriceChange };
};
